// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"554":"5e5855ba","629":"d14602b9","912":"ffcdaa1d"}[chunkId] + ".chunk.css";
};